import AppConstants from 'constants/AppConstants';

export interface ExperimentVariant {
  name: string;
  variant: number | null;
  id: string;
  numVariants: number;
}

export function setExperimentVariants(
  experiments: Array<Partial<ExperimentVariant>>
): BaseTockAction {
  return {
    type: AppConstants.SET_EXPERIMENT_VARIANT,
    payload: {
      experiments,
    },
  };
}
